// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.note-popover-content {\n  padding: 2px 0;\n}\n.note-popover-desc {\n  font-size: 13px;\n  color: #333;\n  margin: 0 0 8px;\n  line-height: 1.5;\n}\n.note-popover-meta {\n  font-size: 11px;\n  color: #888;\n  margin: 0;\n}\n", ""]);
// Exports
module.exports = exports;
